import { render, staticRenderFns } from "./MsDropDown.vue?vue&type=template&id=efdb2a3a&scoped=true&lang=html"
import script from "./MsDropDown.vue?vue&type=script&lang=js"
export * from "./MsDropDown.vue?vue&type=script&lang=js"
import style0 from "./MsDropDown.vue?vue&type=style&index=0&id=efdb2a3a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efdb2a3a",
  null
  
)

export default component.exports